import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { Grid } from "@mui/material";
import { propDateField, propSimpleEnumField } from "../../common/entityStoreForm";
import { propRequired, propValidValue } from "../../common/entityStoreValidators";
import { today, withSameProp } from "../../common/utils";
import { EnumItemDto } from "../../common/enum";

enum RunVariant {
    All = 1 | 2,
    Run = 1,
    Reports = 2,
}

const runVariants: EnumItemDto[] = [
    { id: RunVariant.All, name: "Complete run with reports" },
    { id: RunVariant.Run, name: "Run without reports" },
    { id: RunVariant.Reports, name: "Only payment/return reports" },
];

export const WriteOffRunPage = withSameProp("fake", () => (props: { fake?: boolean }) => {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: { runDate: today(), runVariant: RunVariant.All },
        id: null,
        propValidators: [
            propValidValue("runDate", "runDateFormatted"),
            propRequired("runDate"),
            propRequired("runVariant"),
        ]
    }));
    function renderParams() {
        return <>
            <Grid item xs={12}>{propDateField(useParamsStore)("runDate", "runDateFormatted", "Run date")}</Grid>
            <Grid item xs={12}>{propSimpleEnumField(useParamsStore)("runVariant", "Run variant", runVariants)}</Grid>
        </>;
    }
    return <>
        <Run name="Write-off run" fake={props.fake} hub="writeOffRun"
            useParamsStore={useParamsStore} renderParams={renderParams} />
    </>;
});

interface RunParams {
    runDate: string;
    runDateFormatted?: string;
    runVariant?: RunVariant;
}
